<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-full" :label="__('Description')" />
        </div>

        <div class="flex">
          <div class="p-8 -mr-6 -mb-8 flex">
            <text-input type="number" v-model="form.nday" :error="form.errors.nday" class="pr-6 pb-8 w-full " :label="__('# Days')" />
          </div>
          <div class="p-8 -mr-6 -mb-8 flex">
            <text-input type="number" v-model="form.ndaymax" :error="form.errors.ndaymax" class="pr-6 pb-8 w-full " :label="__('# Days Max')" />
          </div>

          <div class="p-8 -mr-6 -mb-8 flex">
              <text-input type="color" v-model="form.color" :error="form.errors.color" class="pr-6 pb-8 w-full  " :label="__('Color')" />
          </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }}</loading-button>
        </div>
      </form>
    </div> 
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    LoadingButton,
    TextInput,
    Link,
    Head,
  },
  layout: Layout,
  props: {
    description: String
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        description : null,
        nday : null,
        ndaymax : null,
        color: null
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('venciment-color.store'))
    },
  },
}
</script>
